import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

export default function ImageLightbox({ open, onClose, images = [], index = 0, onPrev, onNext }) {
  const canPrev = images.length > 1;
  const canNext = images.length > 1;
  const src = images[index];

  return (
    <Modal open={open} onClose={onClose} center>
      <div style={{ maxWidth: '90vw', maxHeight: '80vh' }}>
        <img src={src} alt="" style={{ maxWidth: '100%', maxHeight: '70vh', display: 'block', margin: '0 auto' }} />
        {images.length > 1 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
            <button disabled={!canPrev} onClick={onPrev}>‹</button>
            <span>{index + 1} / {images.length}</span>
            <button disabled={!canNext} onClick={onNext}>›</button>
          </div>
        )}
      </div>
    </Modal>
  );
}
